import { render, staticRenderFns } from "./DialogNotificationSupportEndCourse.vue?vue&type=template&id=74e5de0b"
import script from "./DialogNotificationSupportEndCourse.vue?vue&type=script&lang=js"
export * from "./DialogNotificationSupportEndCourse.vue?vue&type=script&lang=js"
import style0 from "./DialogNotificationSupportEndCourse.vue?vue&type=style&index=0&id=74e5de0b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports